export const imageCodes = {
    banner: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhome_slider.png?alt=media&token=d27d7527-103c-42a6-a4cb-c1c265064220",
    },
    
    FeaImage: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F22.png?alt=media&token=039cdf64-81b6-42f8-92e5-5575070a5a60",
    },
    
    FeaImage1: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F23.png?alt=media&token=5ac02789-7098-455d-a415-b55f8f646dd9",
    },
    
    FeaImage2: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F24.png?alt=media&token=e789c620-fc40-4131-8748-c8205a30f1a0",
    },

    FeaImage3: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F21.png?alt=media&token=cf09945d-fac9-4b0c-b448-595dc5d851a5",
    },

    FeaImage4: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F20.png?alt=media&token=50c0dda5-6777-43c2-ac18-95ab71f77320",
    },
    
    FeaImage5: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F19.png?alt=media&token=c485457d-b80f-44a3-8497-b569b08192f9",
    },
    
    Artisan: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5.jpg?alt=media&token=55d1e924-f20b-4eac-a288-e0c7e867c618",
    },
    
    scantag: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4.jpg?alt=media&token=d0d41677-2da0-41e9-b25a-7c22a548235a",
    },
 
    BestImage: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F18.png?alt=media&token=165d3dfe-6509-47a6-a175-5d9872462606",
    },
     
    BestImage1: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F17.png?alt=media&token=9687b4b6-94a3-4db1-b54f-25bba5319e95",
    },
     
    BestImage2: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F16.png?alt=media&token=39c1574c-99a9-4583-a38f-a7c86228a97c",
    },
     
    BestImage3: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F15.png?alt=media&token=aebe45e0-8e42-4106-a99d-a9474b31f113",
    },
     
    BestImage4: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F14.png?alt=media&token=ce97c767-1cff-4cec-a9aa-8dad5e069e5c",
    },
     
    BestImage5: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F13.png?alt=media&token=536d3f96-dd76-40e1-8202-6e7ea21b8565",
    },

    NewArival: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F12.png?alt=media&token=54d409e3-ce77-439a-8247-db4c012f44ff",
    },
    
    NewArival1: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F11.png?alt=media&token=ec10b513-72f7-4de6-b735-9c03c4117873",
    },
    
    NewArival2: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F10.png?alt=media&token=d6bb392d-9f5a-4ea3-8509-0ce4214f22cb",
    },
    
    NewArival3: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F9.png?alt=media&token=0f342c5b-9c18-4706-be78-796b41a1ff27",
    },
    
    NewArival4: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F8.png?alt=media&token=e4338301-29cc-4c68-88d3-f561f03a3594",
    },
    
    NewArival5: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F7.png?alt=media&token=38bae824-0c82-4ccf-b168-7627ab3f1b9f",
    },
    
    Sale: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F6.png?alt=media&token=dbe44117-583b-4292-b462-3320c9865d22",
    },
    
    Sale1: {
        code: "${merchantId}_tmpl_img_24",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5.png?alt=media&token=5042c508-08d1-4a05-b8e7-fc600a23f49c",
    },
    
    Sale2: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4.png?alt=media&token=f70c10bb-4292-4dc6-bb1c-82cbfc4b1034",
    },
    
    Sale3: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F3.png?alt=media&token=606a38e4-6620-4a90-9e17-96f14d6db9e3",
    },
    
    Sale4: {
        code: "${merchantId}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F2.png?alt=media&token=15e96dae-5d36-433d-9567-96da106ef9b6",
    },
    
    Sale5: {
        code: "${merchantId}_tmpl_img_28",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F20.png?alt=media&token=27e98019-bf13-476f-8283-a40e147549d9",
    },
    
}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/3ci-o3IxuoQ"
    },

    video2: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/ncKvlu9oDR0"
    },

    video3: {
        code: "${merchantId}_tmpl_video_3",
        video: "https://www.youtube.com/embed/z_-TnNnodJo"
    }
}

export const textCodes = {
    text: {
        code: "${merchantId}_tmpl_text_1",
        text: "Phyo's Handmade is a local brand that empowers artisans and helps people in need in Myanmar. Your purchases support the work of 20+ talented young artisans from different regions of Myanmar. Each of the products is personally created with love."
    },

    ourfav: {
        code: "${merchantId}_tmpl_text_5",
        text: '"Visit our shop to see amazing crafts."'
    },

    pop: {
        code: "${merchantId}_tmpl_text_5",
        text: "Date: 28.10.2022 "
    },

    pop1: {
        code: "${merchantId}_tmpl_text_6",
        text: "Venue: NOVOTEL YANGON MAX"
    },

    pop2: {
        code: "${merchantId}_tmpl_text_7",
        text: "Time: 11:00 am to 8:00 pm"
    },
}

export const titleCodes = {
    About: {
        code: "${merchantId}_tmpl_title_1",
        title: "About Us"
    },

    Fav: {
        code: "${merchantId}_tmpl_title_4",
        title: "Our Favourite"
    },

    tab: {
        code: "${merchantId}_tmpl_title_5",
        title: "Best Seller"
    },

    tab1: {
        code: "${merchantId}_tmpl_title_6",
        title: "New Arrivals"
    },

    tab2: {
        code: "${merchantId}_tmpl_title_7",
        title: "Sales"
    },

    Feat: {
        code: "${merchantId}_tmpl_title_8",
        title: "Feature Products"
    },

    Popup: {
        code: "${merchantId}_tmpl_title_9",
        title: "Pop Up Store Calendar"
    },
    
    SandT: {
        code: "${merchantId}_tmpl_title_10",
        title: "Scan & Tag"
    },

    
}